// Dependency-free so Sidebar and App.tsx can share these without importing the page.
export const DICTIONARY_SNIPPETS_BASE_PATH = '/app/dictionary'

export const DICTIONARY_SNIPPETS_TAB_SLUGS = ['words', 'snippets', 'pending'] as const

export type DictionarySnippetsTabSlug = (typeof DICTIONARY_SNIPPETS_TAB_SLUGS)[number]
